import React from 'react'
import {StickerIcon} from 'yougile-model'
import IconCustomAddChecklist from './add-checklist.svg'
import IconCustomAddParentTask from './add-parent-task.svg'
import IconCustomAlarm from './alarm.svg'
import IconCustomAlertCircle from './alert-circle.svg'
import IconCustomArchive from './archive.svg'
import IconCustomArrowBarRight from './arrow-bar-right.svg'
import IconCustomArrowLeft from './arrow-left.svg'
import IconCustomBan from './ban.svg'
import IconCustomBlueLoader from './blue-loader.svg'
import IconCustomBoardAnalytics from './board-analytics.svg'
import IconCustomBoardCalendar from './board-calendar.svg'
import IconCustomBoardFunnel from './board-funnel.svg'
import IconCustomBolt from './bolt.svg'
import IconCustomBookmark from './bookmark.svg'
import IconCustomBox from './box.svg'
import IconCustomBulb from './bulb.svg'
import IconCustomCalendar from './calendar.svg'
import IconCustomCalendarEvent from './calendar-event.svg'
import IconCustomCalendarRepeat from './calendar-repeat.svg'
import IconCustomChartBar from './chart-bar.svg'
import IconCustomChartDots from './chart-dots.svg'
import IconCustomCheck from './check.svg'
import IconCustomCheckCircle from './check-circle.svg'
import IconCustomChevronDown from './chevron-down.svg'
import IconCustomChevronLeft from './chevron-left.svg'
import IconCustomChevronRight from './chevron-right.svg'
import IconCustomChevronUp from './chevron-up.svg'
import IconCustomCircle from './circle.svg'
import IconCustomCircleCheck from './circle-check.svg'
import IconCustomCircleSuccess from './circle-success.svg'
import IconCustomClose from './close.svg'
import IconCustomCloseAnySize from './close-any.svg'
import IconCustomCloud from './cloud.svg'
import IconCustomCode from './code.svg'
import IconCustomColon from './colon.svg'
import CommentIcon from './comment-icon.svg'
import IconCustomDealComment from './deal-comment.svg'
import IconCustomDollar from './dollar.svg'
import IconCustomDotsVerticalNoPadding from './dots-vertical-no-padding.svg'
import IconCustomDrag from './drag.svg'
import IconCustomEdit from './edit.svg'
import EllipseSystemIcon from './ellipse-system-icon.svg'
import IconCustomEuro from './euro.svg'
import IconCustomExistingPlus from './existing-plus.svg'
import IconCustomExtensionIcon from './extension-icon.svg'
import IconCustomEye from './eye.svg'
import IconCustomFileDescription from './file-description.svg'
import IconCustomFileDownload from './file-download.svg'
import IconCustomFilter from './filter.svg'
import IconCustomFlag from './flag.svg'
import IconCustomFlame from './flame.svg'
import IconCustomGant from './gant.svg'
import IconCustomHeart from './heart.svg'
import IconCustomHistory from './history.svg'
import IconCustomDefaultExtensionIcon from './icons-48/default-extension-icon.svg'
import IconCustomInfoCircle from './info-circle.svg'
import IconInstructionLink from './instruction-link.svg'
import IconCustomKanban from './kanban.svg'
import IconCustomKey from './key.svg'
import IconCustomLayoutBoard from './layout-board.svg'
import IconCustomLink from './link.svg'
import IconCustomLock from './lock.svg'
import IconCustomMapPin from './map-pin.svg'
import IconCustomMessage from './message.svg'
import IconCustomMessageCircle from './message-circle.svg'
import IconCustomMirror from './mirror.svg'
import IconCustomMirroredTask from './mirrored-task.svg'
import IconCustomMirroredTaskTree from './mirrored-task-tree.svg'
import IconCustomMove from './move.svg'
import IconCustomMovie from './movie.svg'
import IconCustomMusic from './music.svg'
import IconCustomPencil from './pencil.svg'
import IconCustomPhoto from './photo.svg'
import IconCustomPin from './pin.svg'
import IconCustomPlus from './plus.svg'
import IconCustomPlusDashed from './plus-dashed.svg'
import IconCustomReminder from './reminder.svg'
import IconCustomRemoveFromBoard from './remove-from-board.svg'
import IconCustomRotateClockwise from './rotate-clockwise.svg'
import IconCustomRotateClockwiseDot from './rotate-clockwise-dot.svg'
import IconCustomRotateRectangle from './rotate-rectangle.svg'
import IconCustomRuble from './ruble.svg'
import IconCustomSearch from './search.svg'
import IconCustomSelectTaskAnySize from './select-tasks-any.svg'
import IconCustomSettings from './settings.svg'
import IconCustomShieldLock from './shield-lock.svg'
import IconCustomSort from './sort.svg'
import IconCustomSortDefault from './sort-default.svg'
import IconCustomSortDown from './sort-down.svg'
import IconCustomSortUp from './sort-up.svg'
import IconCustomStack from './stack.svg'
import IconCustomStar from './star.svg'
import IconCustomStarMark from './star-mark.svg'
import IconCustomSticker from './sticker.svg'
import IconCustomStickerFilterBack from './sticker-filter-back.svg'
import IconCustomStickerFilterBlue from './sticker-filter-blue.svg'
import IconCustomStopwatch from './stopwatch.svg'
import IconCustomTask from './task.svg'
import IconCustomTaskDoneEmpty from './task-done-empty.svg'
import IconCustomTaskDoneEmptySmall from './task-done-empty-small.svg'
import IconCustomTaskDoneFilled from './task-done-filled.svg'
import IconCustomTaskDoneFilledSmall from './task-done-filled-small.svg'
import IconCustomTemplate from './template.svg'
import IconCustomTimeInColumn from './time-in-column.svg'
import IconCustomTimeStop from './time-stop.svg'
import IconCustomTimer from './timer.svg'
import IconCustomTimeTracking from './timetracking.svg'
import IconCustomTools from './tools.svg'
import IconCustomTrash from './trash.svg'
import IconCustomUserCircle from './user-circle.svg'
import IconCustomUserCircleDashed from './user-circle-dashed.svg'
import IconCustomUserCircleDashed20 from './user-circle-dashed.svg'
import IconCustomUsersAdd from './users-add.svg'
import IconCustomVoting from './voting.svg'
import IconCustomWhiteLoader from './white-loader.svg'

export const stickerIcons: Record<
  Exclude<StickerIcon, ''>,
  (props: React.SVGProps<SVGElement>) => React.ReactElement
> = {
  star: IconCustomStar,
  heart: IconCustomHeart,
  check: IconCustomCircleCheck,
  cloud: IconCustomCloud,
  filter: IconCustomFilter,
  alarm: IconCustomAlarm,
  bolt: IconCustomBolt,
  bookmark: IconCustomBookmark,
  box: IconCustomBox,
  bulb: IconCustomBulb,
  prio: IconCustomChartBar,
  code: IconCustomCode,
  ruble: IconCustomRuble,
  dollar: IconCustomDollar,
  euro: IconCustomEuro,
  eye: IconCustomEye,
  flag: IconCustomFlag,
  flame: IconCustomFlame,
  history: IconCustomHistory,
  info: IconCustomInfoCircle,
  key: IconCustomKey,
  anchor: IconCustomMapPin,
  message: IconCustomMessageCircle,
  movie: IconCustomMovie,
  mnote: IconCustomMusic,
  pencil: IconCustomPencil,
  picture: IconCustomPhoto,
  pin: IconCustomPin,
  clockwise: IconCustomRotateClockwise,
  clockwiseDot: IconCustomRotateClockwiseDot,
  rectangle: IconCustomRotateRectangle,
  shield: IconCustomShieldLock,
  stack: IconCustomStack,
  string: IconCustomSticker,
  timeStop: IconCustomTimeStop,
  design: IconCustomTools,
  user: IconCustomUserCircle,
  plus: IconCustomPlus,
  gear: IconCustomSettings,
  sort: IconCustomSort,
  calendar: IconCustomCalendar
}

export const icons = {
  IconCustomArchive,
  IconCustomPlus,
  IconCustomDrag,
  IconCustomPlusDashed,
  IconCustomAddChecklist,
  IconCustomAddParentTask,
  IconCustomArrowBarRight,
  IconCustomStarMark,
  IconCustomClose,
  IconCustomCloseAnySize,
  IconCustomSelectTaskAnySize,
  IconCustomCircleSuccess,
  IconCustomExtensionIcon,
  IconCustomMove,
  IconCustomMirror,
  IconCustomMirroredTask,
  IconCustomMirroredTaskTree,
  IconCustomEdit,
  IconCustomRemoveFromBoard,
  IconCustomStopwatch,
  IconCustomTask,
  IconCustomTaskDoneEmpty,
  IconCustomTaskDoneEmptySmall,
  IconCustomTaskDoneFilled,
  IconCustomTaskDoneFilledSmall,
  IconCustomTemplate,
  IconCustomTimeInColumn,
  IconCustomTimer,
  IconCustomTimeTracking,
  IconCustomUsersAdd,
  IconCustomExistingPlus,
  IconCustomArrowLeft,
  IconCustomSearch,
  IconCustomAlertCircle,
  IconCustomSettings,
  IconCustomFileDescription,
  IconCustomFileDownload,
  IconCustomChevronDown,
  IconCustomChevronUp,
  IconCustomChevronLeft,
  IconCustomChevronRight,
  IconCustomCheckCircle,
  IconCustomCalendar,
  IconCustomCircle,
  IconCustomBan,
  IconCustomColon,
  IconCustomCalendarEvent,
  IconCustomCalendarRepeat,
  IconCustomChartDots,
  IconCustomLayoutBoard,
  IconCustomMessage,
  IconCustomGant,
  IconCustomKanban,
  IconCustomBoardCalendar,
  IconCustomBoardAnalytics,
  IconCustomBoardFunnel,
  IconCustomTrash,
  IconCustomCheck,
  IconCustomUserCircleDashed,
  IconCustomUserCircleDashed20,
  IconCustomStar,
  IconCustomStickerFilterBlue,
  IconCustomStickerFilterBack,
  IconCustomSortDefault,
  IconCustomSortUp,
  IconCustomSortDown,
  IconCustomReminder,
  IconCustomLink,
  IconCustomVoting,
  IconCustomLock,
  IconCustomBlueLoader,
  IconCustomWhiteLoader,
  IconCustomDefaultExtensionIcon,
  IconCustomDotsVerticalNoPadding,
  IconCustomSort,
  IconInstructionLink,
  CommentIcon,
  EllipseSystemIcon,
  IconCustomBolt,
  IconCustomDealComment,
  ...stickerIcons
}

export type CustomIcons = keyof typeof icons

export const customIcons = icons as unknown as {
  [key in CustomIcons]: (
    props: React.SVGProps<SVGElement>
  ) => React.ReactElement
}
